import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField, Typography, FormHelperText, makeStyles } from '@material-ui/core'
import { Add } from '@material-ui/icons'

const SingleAutocomplete = ({
  options = [],
  value = null,
  onChange,
  label = 'Item',
  placeholder = label,
  displayField,
  valueField = 'id',
  error = '',
  disabled = false,
  readOnly = true,
  createNewOption = false,
  createNewLabel = `Create ${label.toLowerCase()}`,
  onCreateNew,
  ...props
}) => {
  const classes = useStyles()

  // Create options with the "Create new" option added if enabled
  const enhancedOptions = createNewOption
    ? [...options, { [displayField]: createNewLabel, isOption: false }]
    : options

  // Find the selected object from its id
  const selectedOption = value ? options.find((item) => item[valueField] === value) : null

  const handleChange = (event, newValue) => {
    // Check if the selected item is the "Create new" option
    if (newValue && newValue.isOption === false) {
      if (onCreateNew) onCreateNew()
      return
    }

    // Extract id from selected item or null if nothing selected
    const selectedId = newValue ? newValue[valueField] : null
    onChange(selectedId)
  }

  return (
    <>
      <Autocomplete
        disableClearable={disabled}
        disabled={disabled}
        options={enhancedOptions}
        value={selectedOption}
        onChange={handleChange}
        getOptionLabel={(option) => (option ? option[displayField] || '' : '')}
        getOptionDisabled={(option) => option.disabled || option.isDivider || option.isInformation}
        renderOption={(option) => {
          if (option.isDivider) {
            return (
              <Typography
                component="div"
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  color: '#616161',
                  width: '100%'
                }}>
                {option[displayField]}
              </Typography>
            )
          } else if (option.isInformation) {
            return (
              <Typography
                component="div"
                style={{
                  padding: '4px 8px',
                  borderRadius: '4px',
                  color: '#616161',
                  width: '100%',
                  textAlign: 'center'
                }}>
                {option[displayField]}
              </Typography>
            )
          }

          return option.isOption === false ? (
            <div className={classes.nonSelectedMenu}>
              <Add />
              <Typography>{option[displayField]}</Typography>
            </div>
          ) : (
            <Typography>{option[displayField]}</Typography>
          )
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={Boolean(error)}
            variant="outlined"
            fullWidth
            InputLabelProps={{
              className: classes.inputLabel
            }}
            InputProps={{
              ...params.InputProps,
              readOnly: readOnly
            }}
            {...props}
          />
        )}
      />
      {error && (
        <FormHelperText error className={classes.errorMsg}>
          {error}
        </FormHelperText>
      )}
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  nonSelectedMenu: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main
  },
  inputLabel: {
    fontSize: '0.875rem'
  },
  errorMsg: {
    marginLeft: '12px'
  }
}))

export default SingleAutocomplete
